const Rails = require("@rails/ujs");

document.addEventListener("turbolinks:load", function () {
  $('#notifications').each(function () {
    $('.edit_consumer_user_notification_setting').on('change', function () {
      Rails.fire(this, 'submit');
    });
  });
});
